import { render, staticRenderFns } from "./MoleculeVisitorCardGroup.vue?vue&type=template&id=60b51055&scoped=true&"
import script from "./MoleculeVisitorCardGroup.vue?vue&type=script&lang=js&"
export * from "./MoleculeVisitorCardGroup.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeVisitorCardGroup.vue?vue&type=style&index=0&id=60b51055&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b51055",
  null
  
)

export default component.exports